export default "__VITE_ASSET__wzLRKYwV__"